import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, InputAdornment, TextField } from "@mui/material"
import { useEffect, useState } from "react"

export const ViewModal = (props: any) => {
    const [ form, setForm ] = useState<any>({});

    const [ hasSetPath, setHasSetPath ] = useState(false);

    useEffect(() => {
        if(!props.open) setHasSetPath(false);
    }, [props.open])
    
    useEffect(() => {
        setForm(props.selected);
    }, [props.selected])

    const submit = () => {
        props.onSubmit?.(form)
    }

    const findParent = (item: any) => {
        if(!item) return;
        let parent = item?.parent;
        let path = item.path;
        if(parent){
          let view = props.views.find((a) => a.id == parent?.id)
          console.log({view})
          path = findParent(view) + path;
        }else{
          
        }
        return path;
    }

    let path = findParent(props.views?.find((a) => a.id == props?.selected?.parent?.id))

    return (
        <Dialog 
            fullWidth
            open={props.open} 
            onClose={props.onClose}>
            <DialogTitle>{props.selected?.id ? "Update" : "Create"} view</DialogTitle>
            <DialogContent>
                <Box sx={{paddingTop: '8px', flexDirection: 'column', display: 'flex', gap: '8px'}}>
                    <TextField 
                        fullWidth
                        value={form?.name || ''}
                        onChange={(e) => {
                            setForm({...form, name: e.target.value, ...(!hasSetPath ? {path: '/' +encodeURI(e.target.value.toLowerCase())} : {}) })
                        
                        }}
                        size="small"
                        label="Name" />

                    <TextField 
                        fullWidth
                        value={form?.path || ''}
                        onChange={(e) => {
                            setForm({...form, path: e.target.value})
                            setHasSetPath(true);
                        }}
                        slotProps={{
                            input: {
                                startAdornment: <InputAdornment sx={{marginRight: 0}} position="start">{path}</InputAdornment>
                            }
                        }}
                        size="small"
                        label="Path" />
                </Box>
            </DialogContent>
            <DialogActions sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: props.selected?.id ? 'space-between' : 'flex-end'
            }}>
                {props.selected?.id ? <Button onClick={props.onDelete} color="error" variant="contained">Delete</Button> : null}
                <Box sx={{display: 'flex'}}>
                    <Button onClick={props.onClose}>Close</Button>
                    <Button onClick={submit} variant="contained">Save</Button>
                </Box>
            </DialogActions>
        </Dialog>
    )
}